import React, { useState } from "react";
import { FadeComponent } from "../fadediv/FadeComponent";
import Utils from "../../utils/Utils";
import { LoaderView } from "../loader/Loader";

export const GoodPossessions = ({ show = true }) => {
  const [loaderStatus, setLoaderStatus] = useState(true);

  const pageUrl = "/api/explained/good-possession-rate";

  return (
    <FadeComponent show={show}>
      <>
        <div className="container stats-explained">
          <div className="text-left">
            <h2>Good Possessions</h2>

            <div className="gray-background-container" style={{ marginBottom: "50px" }}>
              <h5 className="sq-points-tittle" style={{ marginBottom: "30px" }}>
                Good Possessions
              </h5>
              <p className="text-template">
                If a player's possession is above the 66th percentile (of all college basketball) on a play then they
                get credit for a good possession.
              </p>
              <p className="bold-text">The 66th percentile is 1.24 SQpoints for this past season.</p>
              <p className="text-template">
                So, if a player shot a three pointer above 41% then that'd constitute as a good possession. Because the
                SQpoints would be greater than 1.24
              </p>
              <p className="text-template">
                Or, if a player took a 2 point layup that had above a 61 % conversion then that would also count as a
                good possession.Because the SQpoints would be greater than 1.24
              </p>
            </div>
          </div>
        </div>
        <div className="container stats-explained">
          <div className="gray-background-container" style={{ marginBottom: "150px" }}>
            <h5 className="sq-points-tittle" style={{ marginBottom: "30px" }}>
              Good Possession Rate (GPR)
            </h5>

            <p className="text-template">
              This is simply the amount of good possessions a player had divided by total possessions.
            </p>

            <p className="bold-text" style={{ fontSize: "18px", marginBottom: "0px" }}>
              Let's say Player-X had 5 possessions with SQpoints over 1.24.
            </p>
            <p className="bold-text" style={{ fontSize: "18px" }}>
              And had 10 possessions with SQpoints under 1.24.
            </p>

            <p className="bold-text" style={{ fontSize: "18px", marginBottom: "0px" }}>
              Then Player X's Good Possession Rate:
            </p>
            <p className="bold-text" style={{ fontSize: "18px" }}>
              5 (good possessions)/ 15 (total possessions) = .33
            </p>
            <div className="row align-items-center">
              <div className="box col-lg-12">
                <div className="table-responsive">
                  <table className="table">
                    <thead>
                      <tr>
                        <th className="w-50">
                          Rating
                          {/* <i className="fa fa-sort-desc" aria-hidden="true" /> */}
                        </th>
                        <th className="w-50">
                          GPR
                          {/* <i className="fa fa-sort-desc" aria-hidden="true" /> */}
                          <div className="tooltipCon">
                            <b className="d-block">Good Possession Rate</b>
                            The percent of possessions that are in the 66th percentile or above (based on SQpoints). The
                            66th percentile is 1.24 SQpoints.
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Excellent</td>
                        <td>41% or more</td>
                      </tr>
                      <tr>
                        <td>Great</td>
                        <td>35%</td>
                      </tr>
                      <tr>
                        <td>Above Average</td>
                        <td>30%</td>
                      </tr>
                      <tr>
                        <td>Average</td>
                        <td>25%</td>
                      </tr>
                      <tr>
                        <td>Below Average</td>
                        <td>20%</td>
                      </tr>
                      <tr>
                        <td>Poor</td>
                        <td>15%</td>
                      </tr>
                      <tr>
                        <td>Awful</td>
                        <td>10% or less</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </FadeComponent>
  );
};
